import {Component, OnInit} from '@angular/core';

import {ICsGridAction} from '@app/shared/cs-ag-grid-js/cs-ag-grid-js.interface';
import {
    ICsGridActionCellRenderer
} from '@app/shared/cs-ag-grid-js/cs-ag-grid-cell-renderers/cs-ag-grid-cell-renderers.interface';
import {CsAgGridJsService} from '@app/shared/cs-ag-grid-js/cs-ag-grid-js.service';

@Component({
    selector: 'app-cs-ag-grid-action-renderer',
    templateUrl: './cs-ag-grid-action-renderer.component.html',
    styleUrls: ['../../../../features/v5-common-styles/utils.scss']
})
export class CsAgGridActionRendererComponent implements OnInit {

    // Note: Need to define the same property as `params: <Respective interface type> & { [k: string]: any }` on all custom renderer.
    params: ICsGridActionCellRenderer & { [k: string]: any };
    rowNode: any;

    constructor(private _csAgGrid: CsAgGridJsService) {
    }

    ngOnInit() {
        this.rowNode = this.params.node;
    }

    isDisable(action: ICsGridAction): boolean {
        return typeof action.disable === 'function' ? action.disable(this.params['data']) : action.disable;
    }

    isHide(action: ICsGridAction): boolean {
        return typeof action.hide === 'function' ? action.hide(this.params['data']) : action.hide;
    }

    isDisabledTooltip(action: ICsGridAction): boolean {
        return typeof action.showTooltipIfDisabled === 'function' ? action.showTooltipIfDisabled(this.params['data']) : action.showTooltipIfDisabled;
    }

    onClickAction(action: ICsGridAction) {
        if (this.isDisable(action)) { return; }

        action.onClick({
            action: action.id,
            data: this.params['data'],
            updateCellValue: this.updateCellValue
        });
    }

    private updateCellValue = (rowData: object) => {
        this._csAgGrid.updateNodeCellValue(this.rowNode, rowData);
    }

    getActionUrl(action: ICsGridAction): string {
        if (typeof action.linkUrl === 'function') {
            return action.linkUrl(this.params['data']);
        }
        return action.linkUrl || '#';
    }

    onClickLinkAction(action: ICsGridAction, event: MouseEvent): void {
        if (this.isDisable(action)) {
            event.preventDefault();
            return;
        }
        if (event.ctrlKey || event.metaKey || event.button === 1) {
            return;
        }
        event.preventDefault();
        action.onClick({
            action: action.id,
            data: this.params['data'],
            updateCellValue: this.updateCellValue
        });
    }
}
